import { ObraHeaderInfo } from "../../domain/models/obra_header_info";
import { ObrasTopHeaderState } from "./hooks/obras_top_header_state";
import { IrParaModal } from "./ir_para_modal";
import { PageTopBar, ThreeSlotLayout } from "../../../../common/components/page_top_bar";
import { BackButton } from "../../../../common/components/back_button";
import { ObrasReportButton } from "./obras_report_button";
import { ObrasCommonReportsState } from "./hooks/obras_common_reports";
import { ReactNode } from "react";

import PrimaryButton from "../../../../common/components/primary_button";

/**
 * ObrasTopBar
 */

type Props = {
  obrasReportState: ObrasCommonReportsState;
  selectedObra: ObraHeaderInfo | null;
  state: ObrasTopHeaderState;
  rightSlot?: ReactNode;
  leftBackSlotButton?: ReactNode;
  leftReportSlotButton?: ReactNode;
  onBack: () => void;
};

export const ObrasTopBar = ({
  obrasReportState,
  selectedObra,
  state,
  leftBackSlotButton,
  leftReportSlotButton,
  children,
  onBack,
}: React.PropsWithChildren<Props>) => {
  return (
    <PageTopBar>
      <div className="w-full flex flex-col justify-between items-center">
        <ThreeSlotLayout
          leftSlot={
            children
          }
          centerSlot={
            <div className="w-[120px]">
              <PrimaryButton
                buttonColor="orange"
                size="small"
                onClick={() => state.handleIrParaModalOpenState(true)}>
                Ir para...
              </PrimaryButton>
            </div>
          }
          rightSlot={
            <div className="justify-end flex gap-2">
              <PrimaryButton
                onClick={() => {
                  if (selectedObra) {
                    state.handleIrParaIndicador(selectedObra.idObra);
                  }
                }}>
                Indicador
              </PrimaryButton>
              {leftReportSlotButton}
              {
                (selectedObra && selectedObra.idObra) &&
                <>
                  {
                    <ObrasReportButton
                      state={obrasReportState}
                    />
                  }
                </>
              }
              {leftBackSlotButton}
              <BackButton
                onClick={onBack}
              />
            </div>
          }
        />
      </div>

      {/**
        * Modals
        */}

      <IrParaModal
        open={state.openIrParaModal}
        selectedObra={selectedObra ?? null}
        onClose={() => state.handleIrParaModalOpenState(false)}
        onExecuteAction={state.handleIrParaExecuteAction}
      />
    </PageTopBar>
  );
}